/* Bandenmeesters trustbar — canonical four benefits, rotating only on mobile. */
(()=>{
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const bars=new Set();

  const stop=bar=>{
    if(bar._bmAnnouncementTimer){
      window.clearInterval(bar._bmAnnouncementTimer);
      bar._bmAnnouncementTimer=0;
    }
    if(bar._bmAnnouncementSwap){
      window.clearTimeout(bar._bmAnnouncementSwap);
      bar._bmAnnouncementSwap=0;
    }
  };

  const readItems=bar=>{
    const source=bar.querySelector('[data-bm-trust-items]');
    if(!source)return [];
    try{
      const parsed=JSON.parse(source.textContent||'[]');
      return Array.isArray(parsed)?parsed.map(value=>String(value||'').trim()).filter(Boolean):[];
    }catch(_){return []}
  };

  const start=bar=>{
    stop(bar);
    const label=bar.querySelector('[data-bm-trust-mobile-text]');
    const items=readItems(bar);
    if(!label||!items.length)return;

    let index=Math.max(0,items.indexOf(label.textContent.trim()));
    label.textContent=items[index]||items[0];
    label.classList.remove('is-changing');

    if(items.length<2)return;
    bar._bmAnnouncementTimer=window.setInterval(()=>{
      if(document.hidden)return;

      const swap=()=>{
        index=(index+1)%items.length;
        label.textContent=items[index];
        label.classList.remove('is-changing');
        bar._bmAnnouncementSwap=0;
      };

      if(reduced.matches){
        swap();
        return;
      }

      label.classList.add('is-changing');
      bar._bmAnnouncementSwap=window.setTimeout(swap,170);
    },3600);
  };

  const init=(scope=document)=>{
    scope.querySelectorAll('[data-bm-announcement]').forEach(bar=>{
      if(!bars.has(bar))bars.add(bar);
      bar.dataset.bmAnnouncementReady='true';
      start(bar);
    });
  };

  const remove=(scope)=>{
    bars.forEach(bar=>{
      if(scope.contains?.(bar)||bar===scope){
        stop(bar);
        bars.delete(bar);
      }
    });
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();

  reduced.addEventListener?.('change',()=>bars.forEach(start));
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>remove(event.target));
})();
